import styled from '@emotion/styled';
import type { ErrorTextSize, LabelWeight } from './types';

export const FieldRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme?.component?.formField?.gap ?? '0.25rem'};
  width: 100%;
  box-sizing: border-box;
`;

export const StyledLabel = styled.label<{ $weight: LabelWeight }>`
  display: block;
  font-family: inherit;
  color: ${({ theme }) => theme?.colors?.text?.primary ?? '#292929'};
  font-weight: ${({ theme, $weight }) =>
    theme?.component?.formField?.label?.[$weight]?.fontWeight ??
    ($weight === 'bold' ? 700 : $weight === 'semibold' ? 600 : 400)};
  font-size: ${({ theme, $weight }) =>
    theme?.component?.formField?.label?.[$weight]?.fontSize ?? '0.875rem'};
  margin-bottom: 0;
`;

export const RequiredMark = styled.span`
  color: ${({ theme }) =>
    theme?.component?.formField?.requiredMark?.color ??
    theme?.colors?.semantic?.urgent?.color ??
    '#c64844'};
  margin-left: 0.25rem;
`;

export const StyledErrorText = styled.span<{ $size: ErrorTextSize }>`
  display: block;
  color: ${({ theme }) =>
    theme?.component?.formField?.error?.color ??
    theme?.colors?.semantic?.urgent?.color ??
    '#c64844'};
  font-size: ${({ theme, $size }) =>
    $size === 'sm'
      ? '0.75rem'
      : theme?.component?.formField?.error?.fontSize ?? '0.875rem'};
  margin-top: 0;
  font-family: inherit;
`;

export const HelpText = styled.span`
  display: block;
  color: ${({ theme }) => theme?.colors?.text?.secondary ?? '#808080'};
  font-size: 0.875rem;
  font-family: inherit;
`;
